// removed by extract-text-webpack-plugin
module.exports = {"mainCon":"_1w0r8spA-Tlgh5ZPdqmn7i","textCon":"CkjkkWzFPSTVrwaW5gjai","xButton":"_16zTtuPtwLlUNHk66lIDm4","buttonWrapper":"_2BnE00r2sNTw6iWrqv5QhN"};


//////////////////
// WEBPACK FOOTER
// ./elements/CookieBanner.scss
// module id = 1181
// module chunks = 0